/**
 * Toggles the visibility of the credentials section based on the selected carrier type and OAuth status.
 *
 * @param {HTMLSelectElement} carrierTypeSelect - The select element for choosing the carrier type.
 * @param {number} oAuth - The OAuth status (1 for enabled, other values for disabled).
 */
function showCredentialsSection (carrierTypeSelect, oAuth) {
    if ((carrierTypeSelect.value == 1 && oAuth != 1) || (carrierTypeSelect.value == 2)) {
        $("#credentials").show();
    } else {
        $("#credentials").hide();
    }

    //for FedEx show tracking Credentials fields
    if (carrierTypeSelect.value == 2) {
        $("#tracking_credentials").show();
    }
}

$(document).on('click', '.deleteCarrierBtn', function(e) {
    e.preventDefault();
    var carrierId = $(this).data('id');

    swal({
        title: 'Are you sure?',
        text: 'Delete this Carrier!',
        icon: 'warning',
        buttons: {
            cancel: {
                text: 'Cancel',
                value: null,
                visible: true,
                className: 'btn btn-default',
                closeModal: true,
            },
            confirm: {
                text: 'Delete',
                value: true,
                visible: true,
                className: 'btn btn-danger',
                closeModal: true
            }
        }
    }).then((result) => {
        if (result) {
            // User confirmed deletion
            $.ajax({
                headers: { 'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content') },
                method: 'get',
                url: '/carriers/delete',
                data: { carrierId: carrierId },
                success: function(response) {

                    if(response.status=='success'){
                        swal('Deleted!', response.message, 'success');
                    }else{
                        swal('Error!', 'Carrier Not Found', 'error');
                    }
                    setTimeout(function () {
                        location.reload();
                    }, 200);
                },
                error: function(error) {
                    // Handle error
                    swal('Error!', 'An error occurred while deleting the Carrier.', 'error');
                }
            });
        }
    });
});

$(document).on('click', '.toggleCarrierBtn', function(e) {
    e.preventDefault();
    var carrierId = $(this).data('id');
    var action = $(this).data('action');
    var actionText = action === 'disable' ? 'Disable' : 'Enable';

    swal({
        title: 'Are you sure?',
        text: actionText + ' this Carrier!',
        icon: 'warning',
        buttons: {
            cancel: {
                text: 'Cancel',
                value: null,
                visible: true,
                className: 'btn btn-default',
                closeModal: true,
            },
            confirm: {
                text: actionText,
                value: true,
                visible: true,
                className: action === 'disable' ? 'btn btn-warning' : 'btn btn-success',
                closeModal: true
            }
        }
    }).then((result) => {
        if (result) {
            // User confirmed action
            $.ajax({
                headers: { 'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content') },
                method: 'get',
                url: '/carriers/toggle',
                data: { carrierId: carrierId },
                success: function(response) {
                    if(response.status=='success'){
                        swal(actionText + 'd!', response.message, 'success');
                        setTimeout(function () {
                            location.reload();
                        }, 200);
                    }else{
                        swal('Error!', 'Carrier Not Found', 'error');
                    }
                },
                error: function(error) {
                    // Handle error
                    swal('Error!', 'An error occurred while ' + action + 'ing the Carrier.', 'error');
                }
            });
        }
    });
});

